import { Injectable } from '@angular/core';
import { BaseChainBaseGuard } from '../../internal';

@Injectable({
  providedIn: 'root'
})
export class UserSharedGuard extends BaseChainBaseGuard {
  override async canActivate(): Promise<boolean> {
    return true;
    // return new Promise((resolve, reject) => {
    //   const expiresIn = this.baseChainGuardFacade.snapshot_expiresIn();
    //   if (!expiresIn || expiresIn < Math.round(Date.now() / 1000)) {
    //     this.baseChainGuardFacade.requestLogout().subscribe(() => {
    //       resolve(true);
    //     });
    //   } else if (this.baseChainGuardFacade.snapshot_user() === null) {
    //     this.baseChainGuardFacade.ofActionDispatchedMeSuccess.subscribe(() => {
    //       setTimeout(() => {
    //         resolve(true);
    //       }, 200);
    //     });
    //     this.baseChainGuardFacade.requestMe();
    //   } else {
    //     resolve(true);
    //   }
    // });
  }
}
